import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Logout as LogoutAction } from '../../store/slices/loginSlice';
import styles from './header.module.css';
import { CgProfile } from 'react-icons/cg';
import { MdMenu, MdClose } from 'react-icons/md';
import { Dropdown, Menu, Button, Badge, Avatar, Select } from 'antd';
import { BellOutlined, MessageOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { getDecodedToken } from '../../utils/auths';
import { useSidebar } from '../../context/SidebarContext';
import { useMsal } from '@azure/msal-react';
// import { changeAppLanguage } from "../../i18n";
import Profile from '../../assets/images/undraw_profile.svg'
import Eng from '../../assets/images/uk-flag-round-circle-icon.svg'
import Arb from '../../assets/images/saudi-arabia-flag-round-circle-icon.svg'
import NotificationImage from '../../assets/images/icon/BadgeGroup.svg'
import GroupImage from '../../assets/images/icon/Users.svg'
import Avator1 from '../../assets/images/undraw_profile.svg'
import Avator2 from '../../assets/images/undraw_profile_1.svg'
import DocumentImage from '../../assets/images/icon/shape.svg'
import ErrorImage from '../../assets/images/down-aar.png'
import DollarImage from '../../assets/images/doc-icons.svg'

interface HeaderProps {
  Logout: () => Promise<{ success: boolean; message?: string }>;
}

const { Option } = Select;


const Header: React.FC<HeaderProps> = ({ Logout }) => {
  const navigate = useNavigate();
  const { collapsed, toggleSidebar } = useSidebar();
  const { instance, accounts } = useMsal();
  const [notificationCount, setNotificationCount] = useState('3+');
  const [messageCount, setMessageCount] = useState(2);
//   const { t, i18n } = useTranslation();

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key === 'profile') {
      navigate('/profile');
    } else if (key === 'changePassword') {
      navigate('/change-password');
    } else if (key === 'logout') {
      void (async () => {
        await Logout();
        const account = accounts[0];
        if (account) {
          instance.logoutRedirect({ account, postLogoutRedirectUri: '/' });
        } else {
          navigate('/');
        }
      })();
    }
  };

//   const handleLanguageChange = (lang: string) => {
//     changeAppLanguage(lang);
//   };

  // Notification Menu
  const notificationMenu = (
    <div
      style={{
        width: 300,
        maxHeight: 440,
        borderRadius: 6,
        overflowY: "hidden",
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
        // background: theme?.colors?.Headerbg || "#fff",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          background: "#111827",
          padding: "5px 14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            color: "#fff",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: 0.8,
            textTransform: "uppercase",
          }}
        >
          Alerts Center
        </div>
        {/* unread count bubble (optional) */}
        {/* <div
        style={{
          background: "#4ECDC4",
          color: "#08202A",
          fontWeight: 700,
          fontSize: 12,
          padding: "4px 9px",
          borderRadius: 18,
        }}
      >
        3
      </div> */}
      </div>

      {/* BODY (scrollable) */}
      <div style={{ maxHeight: 340, overflowY: "auto" }}>
        <Menu
          selectable={false}
          style={{
            width: "100%",
            border: "none",
            background: "transparent",
          }}
        >
          <Menu.Item key="1" style={{ padding: "12px 14px" }}>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              {/* icon bubble */}
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  background: "#0d6efd",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: 18,
                  flexShrink: 0,
                }}
              >
                <img src={DocumentImage} alt='' width={15} />
              </div>

              {/* text */}
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontWeight: 400,
                    marginBottom: 6,
                    // lineHeight:20.6,
                    fontFamily:"inter",
                    color: "rgb(33, 37, 41)",
                    fontSize: 13.6,
                    
                  }}
                >
                  December 12, 2019
                </div>
                <div style={{ fontSize: 13, color: "#666", lineHeight: "18px" }}>
                  A new monthly report is ready to download!
                </div>
              </div>
            </div>
          </Menu.Item>
          <Menu.Divider />

          <Menu.Item key="2" style={{ padding: "12px 14px" }}>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  background: "#1e8a58",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: 18,
                  flexShrink: 0,
                }}
              >
                💰
              </div>

              <div style={{ flex: 1 }}>
                <div
                  style={{
                fontWeight: 400,
                    marginBottom: 6,
                    // lineHeight:20.6,
                    fontFamily:"inter",
                    color: "rgb(33, 37, 41)",
                    fontSize: 13.6,
                  }}
                >
                  December 7, 2019
                </div>
                <div style={{ fontSize: 13, color: "#666", lineHeight: "18px" }}>
                  $290.29 has been deposited into your account!
                </div>
              </div>
            </div>
          </Menu.Item>
          <Menu.Divider />

          <Menu.Item key="3" style={{ padding: "12px 14px" }}>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  background: "#ffc107",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: 18,
                  flexShrink: 0,
                }}
              >
                ⚠️
              </div>

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontWeight: 400,
                    marginBottom: 6,
                    // lineHeight:20.6,
                    fontFamily:"inter",
                    color: "rgb(33, 37, 41)",
                    fontSize: 13.6,
                  }}
                >
                  December 2, 2019
                </div>
                <div style={{ fontSize: 13, color: "#666", lineHeight: "18px" }}>
                  Spending Alert: We've noticed unusually high spending for your account.
                </div>
              </div>
            </div>
          </Menu.Item>

          <Menu.Divider />
          <Menu.Item key="view-all" style={{ padding: "8px 14px" }}>
            <div
              style={{
                textAlign: "center",
                color: "#4ECDC4",
                fontWeight: 600,
                padding: "5px 0",
                cursor: "pointer",

              }}
              onClick={() => {
                // replace with your navigation/action
                console.log("Show All Alerts clicked");
              }}
            >
              Show All Alerts
            </div>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );


  // Message Menu
  const messageMenu = (
    <div
      style={{
        width: 300,
        maxHeight: 440,
        borderRadius: 6,
        overflow: "hidden",
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          background: '#111827',
          padding: "5px 14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            color: "#fff",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: 0.8,
            textTransform: "uppercase",
          }}
        >
          Messages
        </div>

        {/* unread count bubble (optional)
      <div
        style={{
          background: "#4ECDC4",
          color: "#08202A",
          fontWeight: 700,
          fontSize: 12,
          padding: "4px 9px",
          borderRadius: 18,
        }}
      >
        2
      </div> */}
      </div>

      {/* BODY */}
      <div style={{ maxHeight: 340, overflowY: "auto" }}>
        <Menu
          selectable={false}
          style={{
            width: "100%",
            border: "none",
            background: "transparent",
          }}
        >
          <Menu.Item key="1" style={{ padding: "12px 14px" }}>
            <div style={{ display: "flex", gap: 10 }}>
              <Avatar
                src={Avator1}
                size={40}
              />

              <div>
                <div
                  style={{
                    fontWeight: 400,
                    marginBottom: 6,
                    // lineHeight:20.6,
                    fontFamily:"inter",
                    color: "rgb(33, 37, 41)",
                    fontSize: 13.6,
                  }}
                >
                  Sarah Johnson
                </div>
                <div style={{ fontSize: 12, color: "#666" }}>
                  Hey, can you review my report?
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#999",
                    marginTop: 2,
                  }}
                >
                  5 min ago
                </div>
              </div>
            </div>
          </Menu.Item>
          <Menu.Divider />

          <Menu.Item key="2" style={{ padding: "12px 14px" }}>
            <div style={{ display: "flex", gap: 10 }}>
              <Avatar
                src={Avator2}
                size={40}
              />

              <div>
                <div
                  style={{
                    fontWeight: 400,
                    marginBottom: 6,
                    // lineHeight:20.6,
                    fontFamily:"inter",
                    color: "rgb(33, 37, 41)",
                    fontSize: 13.6,
                  }}
                >
                  Michael Brown
                </div>
                <div style={{ fontSize: 12, color: "#666" }}>
                  Meeting at 3 PM today
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#999",
                    marginTop: 2,
                  }}
                >
                  30 min ago
                </div>
              </div>
            </div>
          </Menu.Item>

          <Menu.Divider />

          <Menu.Item key="view-all" style={{ padding: "8px 14px" }}>
            <div
              style={{
                textAlign: "center",
                color: "#4ECDC4",
                fontWeight: 600,
                padding: "8px 0",
                cursor: "pointer",
              }}
            >
              View All Messages
            </div>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );


  // Profile Menu
  const profileMenu = (
    <Menu
      onClick={handleMenuClick}
      items={[
        {
          key: "changePassword",
          icon: <SettingOutlined />,
          label: <span>Change Password</span>,
        },
        {
          type: "divider",
        },
        {
          key: "logout",
          icon: <LogoutOutlined />,
          label: <span >Logout</span>,
          danger: true,
        },
      ]}
    />
  );


  const UserName = getDecodedToken()?.userName || localStorage.getItem('userName') || 'User'


  const items = [
    {
      key: "en",
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={Eng} width={20} style={{ marginRight: 8 }} />
          English
        </div>
      )
    },
    {
      key: "ar",
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={Arb} width={20} style={{ marginRight: 8 }} />
          العربية
        </div>
      )
    }
  ];
  return (
    <div
      className={`container-fluid ${styles.container}`}
    >
      <div className={styles.leftSection}>
        <button 
          className={styles.toggleButton}
          onClick={toggleSidebar}
        >
          {collapsed ? <MdMenu /> : <MdClose />}
        </button>
      </div>
      <div className={styles.rightSection}>
        {/* <div className={styles.iconContainer}>
        <Dropdown overlay={notificationMenu} trigger={["click"]} placement="bottomRight">
          <div className={styles.iconWrapper}>
            <Badge count={notificationCount} offset={[-2, 17]} style={{
              borderRadius: 4,        
              width: 20,
              height: 14,
              lineHeight: "18px",
              textAlign: "center",
              padding: 0,
              background: "#eb5e51ff",
              fontSize: '10px'
            }}>
              <img src={NotificationImage} alt='' className={styles.icon} style={{ color: theme.colors.profileDropdownText }} />
            </Badge>
          </div>
        </Dropdown>

        <Dropdown overlay={messageMenu} trigger={["click"]} placement="bottomRight">
          <div className={styles.iconWrapper}>
            <Badge count={messageCount} offset={[8, 10]} style={{
              borderRadius: 4,        
              width: 10,
              height: 14,
              lineHeight: "18px",
              textAlign: "center",
              padding: 0,
              background: "#eb5e51ff",
              fontSize: '10px'

            }}>
              <img src={GroupImage} alt='' className={styles.icon} style={{ color: theme.colors.profileDropdownText }} />
            </Badge>
          </div>
        </Dropdown>
        </div> */}

        {/* Country Flag */}
        {/* <div className={styles.headerFlag}>
          <div className={styles.flagbx}>
            <div className={styles.flagWrapper}>
              <Dropdown
                menu={{
                  items,
                  onClick: ({ key }) => handleLanguageChange(key)
                }}
                placement="bottomLeft"
                trigger={["click"]}
              >
                <div style={{ cursor: "pointer" }}>
                  <img
                    src={i18n.language === "en" ? Eng : Arb}
                    width={30}
                    style={{ display: "block" }}
                  />
                </div>
              </Dropdown>
            </div>
          </div>
        </div> */}

        {/* Profile Dropdown */}
        <Dropdown overlay={profileMenu} placement="bottomRight" trigger={['click']}>
          <Button
            type="text"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            {/* <CgProfile size={32} /> */}
            <img src={Profile} alt="" width={30} />
            <p className={styles.userNameText}>{UserName}</p>
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

export default connect(null, { Logout: LogoutAction })(Header);